// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page_404 img {
  width:100%;
}

.four_zero_four_bg {
  background-image: url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif);
  height: 400px;
  background-position: center;
  padding-top: 40px;
}

.four_zero_four_bg h1 {
  font-size:var(--app-font-size-80px);
}

.four_zero_four_bg h3 {
  font-size:var(--app-font-size-80px);
}

.link_404 {
	color: var(--app-white)!important;
  padding: 10px 20px;
  background: var(--app-legacy-page-not-found-background);
  margin: 20px 0;
  display: inline-block;
}

.contant_box_404{ margin-top:-50px;}
`, "",{"version":3,"sources":["webpack://./src/app/main/page-not-found/page-not-found.component.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,+FAA+F;EAC/F,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;CACC,iCAAiC;EAChC,kBAAkB;EAClB,uDAAuD;EACvD,cAAc;EACd,qBAAqB;AACvB;;AAEA,kBAAkB,gBAAgB,CAAC","sourcesContent":[".page_404 img {\n  width:100%;\n}\n\n.four_zero_four_bg {\n  background-image: url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif);\n  height: 400px;\n  background-position: center;\n  padding-top: 40px;\n}\n\n.four_zero_four_bg h1 {\n  font-size:var(--app-font-size-80px);\n}\n\n.four_zero_four_bg h3 {\n  font-size:var(--app-font-size-80px);\n}\n\n.link_404 {\n\tcolor: var(--app-white)!important;\n  padding: 10px 20px;\n  background: var(--app-legacy-page-not-found-background);\n  margin: 20px 0;\n  display: inline-block;\n}\n\n.contant_box_404{ margin-top:-50px;}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
